const API = "https://iworkuntil.com/api";
const UID_KEY = "ms-landing-uid";

function getUid() {
  let uid = localStorage.getItem(UID_KEY);
  if (!uid) {
    uid =
      Math.random().toString(36).slice(2) +
      Math.random().toString(36).slice(2);
    localStorage.setItem(UID_KEY, uid);
  }
  return uid;
}

export function track(event) {
  try {
    fetch(`${API}/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event,
        uid: getUid(),
        project: "moodsense",
        platform: "landing",
        env: window.location.hostname === "localhost" ? "dev" : "prod",
      }),
    }).catch(() => {});
  } catch {
    // silently ignore
  }
}
